import { Lang } from "./i18n";

export const icpRecord = {
  label: "粤ICP备12059233号",
  href: "https://beian.miit.gov.cn/",
};

export const publicSecurityRecord = {
  label: "",
  href: "https://beian.mps.gov.cn/#/query/webSearch",
};

export function privacyPath(lang: Lang) {
  return lang === "zh" ? "/cn/ai-receptionist/privacy" : "/ai-receptionist/privacy-policy";
}

export function cookiePath(lang: Lang) {
  return lang === "zh" ? "/cn/ai-receptionist/cookie-policy" : "/ai-receptionist/cookie-policy";
}

export function termsPath(lang: Lang) {
  return lang === "zh" ? "/cn/ai-receptionist/terms-of-use" : "/ai-receptionist/terms-of-use";
}

export function aboutPath(lang: Lang) {
  return lang === "zh" ? "/cn/ai-receptionist/about" : "/ai-receptionist/about";
}
